module.exports = __webpack_public_path__ + "static/media/ZSMTC.8299420f.pdf";